export const PUBLIC_FORMS_RESET = 'PUBLIC_FORMS_RESET'

export const PUBLIC_FORM_CREATE = 'PUBLIC_FORM_CREATE'
export const PUBLIC_FORM_CREATE_SUCCESS = 'PUBLIC_FORM_CREATE_SUCCESS'
export const PUBLIC_FORM_CREATE_FAILED = 'PUBLIC_FORM_CREATE_FAILED'

export const PUBLIC_FORM_DELETE = 'PUBLIC_FORM_DELETE'
export const PUBLIC_FORM_DELETE_SUCCESS = 'PUBLIC_FORM_DELETE_SUCCESS'
export const PUBLIC_FORM_DELETE_FAILED = 'PUBLIC_FORM_DELETE_FAILED'

export const PUBLIC_FORM_UPDATE = 'PUBLIC_FORM_UPDATE'
export const PUBLIC_FORM_UPDATE_SUCCESS = 'PUBLIC_FORM_UPDATE_SUCCESS'
export const PUBLIC_FORM_UPDATE_FAILED = 'PUBLIC_FORM_UPDATE_FAILED'

export const NOTIFICATIONS_FETCH = 'NOTIFICATIONS_FETCH'
export const NOTIFICATIONS_FETCH_SUCCESS = 'NOTIFICATIONS_FETCH_SUCCESS'
export const NOTIFICATIONS_FETCH_FAILED = 'NOTIFICATIONS_FETCH_FAILED'

export const PUBLIC_FORM_CLONE = 'PUBLIC_FORM_CLONE'
export const PUBLIC_FORM_CLONE_SUCCESS = 'PUBLIC_FORM_CLONE_SUCCESS'
export const PUBLIC_FORM_CLONE_FAILED = 'PUBLIC_FORM_CLONE_FAILED'

export const SET_PUBLIC_FORM_TEMPLATES_ORDER = 'SET_PUBLIC_FORM_TEMPLATES_ORDER'
